﻿import { Controller } from "@hotwired/stimulus";
import Flickity from "flickity";
import "flickity-as-nav-for";
import pDebounce from "p-debounce";

export default class extends Controller {
    static get values() {
        return {
            customAmountText: String,
            calculatePointsForCustomVariantAmountUrl: String
        }
    }

    static get targets() {
        return ["imageCarousel", "imageCarouselNav", "price", "points", "customVariant", "customVariantAmount", "giftRecipient", "giftOther"];
    }

    initialize() {
        this.calculatePointsForCustomVariantAmount = pDebounce(this.calculatePointsForCustomVariantAmount, 250);
    }

    imageCarouselTargetConnected() {
        this.imageCarouselTarget.flickity = new Flickity(
            this.imageCarouselTarget,
            {
                cellAlign: "left",
                contain: true,
                pageDots: false,
                // arrowShape: "M98.4,86c0,6.6-5.4,12-12,12h-72c-6.6,0-12-5.4-12-12V14c0-6.6,5.4-12,12-12h72c6.6,0,12,5.4,12,12V86z M71.4,47H36.7 l12.9-12.9c1.2-1.2,1.2-3.1,0-4.2s-3.1-1.2-4.2,0l-18,18c-1.2,1.2-1.2,3.1,0,4.2c0,0,0,0,0,0l18,18c1.2,1.2,3.1,1.2,4.2,0c1.2-1.2,1.2-3.1,0-4.2L36.7,53h34.8c1.7,0,3-1.3,3-3C74.4,48.4,73.1,47,71.4,47z"
            }
        );
    }

    imageCarouselNavTargetConnected() {
        this.imageCarouselNavTarget.flickity = new Flickity(
            this.imageCarouselNavTarget,
            {
                asNavFor: this.imageCarouselTarget,
                cellAlign: "left",
                contain: true,
                prevNextButtons: false,
                pageDots: false
            }
        );
    }

    displaySelectedVariant({ target }) {
        const variantId = target.options[target.selectedIndex].dataset.variantId;
        const variantImage = this.imageCarouselTarget.querySelector(`[data-variant-id="${variantId}"]`);
        const imageIndex = variantImage ? Array.prototype.indexOf.call(variantImage.parentNode.children, variantImage) : 0;
        this.imageCarouselTarget.flickity.select(imageIndex, false, true);

        if (this.hasImageCarouselNavTarget) {
            this.imageCarouselTarget.flickity.select(imageIndex, false, true);
        }

        const price = target.options[target.selectedIndex].dataset.price;

        if (this.hasPriceTarget && price) {
            this.priceTarget.innerHTML = price;
        }

        const points = target.options[target.selectedIndex].dataset.points;
        const preSalePoints = target.options[target.selectedIndex].dataset.preSalePoints;
        this.pointsTarget.innerHTML = preSalePoints ?
            `
            <span class="text-decoration-line-through text-secondary">${preSalePoints}</span>
            &nbsp;
            <span class="text-danger">${points}</span>
            ` :
            points;
        this.customVariantTarget.classList.toggle("d-none", variantId !== "-1");

        if (variantId === "-1") {
            this.updateCustomVariantPoints();
        }
    }

    updateCustomVariantPoints() {
        if (this.customVariantAmountTarget.value) {
            void this.refreshCustomVariantPoints();
        } else {
            this.pointsTarget.innerHTML = this.customAmountTextValue;
        }
    }

    async refreshCustomVariantPoints() {
        if (!this.pointsTarget.querySelector(".spinner-border")) {
            this.pointsTarget.innerHTML = `<div class="spinner-border"></div>`;
        }

        this.pointsTarget.innerHTML = await this.calculatePointsForCustomVariantAmount();
    }

    async calculatePointsForCustomVariantAmount() {
        const url = new URL(this.calculatePointsForCustomVariantAmountUrlValue, document.location.origin);
        url.searchParams.set("customVariantAmount", this.customVariantAmountTarget.value);
        const response = await fetch(url);
        return await response.text();
    }

    setCustomVariantAmount(e) {
        e.preventDefault();
        this.customVariantAmountTarget.value = e.params.customVariantAmount;
        this.customVariantAmountTarget.focus();
        void this.updateCustomVariantPoints();
    }

    configureGiftFormForRecipientType({ target }) {
        const isSelfRecipientTypeSelected = target.options[target.selectedIndex].value === "self";
        this.giftRecipientTargets.forEach(grt => {
            grt.value = isSelfRecipientTypeSelected && grt.dataset.initialValue || "";
        });
        this.giftOtherTarget.classList.toggle("hide", isSelfRecipientTypeSelected);
    }
}
